// HEADER
document.querySelector(".menu-burger").addEventListener("click", function () {
  this.classList.toggle("active");
  document.getElementById("mobile-menu").classList.toggle("open");
});

// MENU SUB-MENU
document
  .querySelectorAll("#mobile-menu .menu-item.menu-item-has-children")
  .forEach(function (menuItem) {
    menuItem.addEventListener("click", function (event) {
      if (window.matchMedia("(max-width: 1280px)").matches) {
        if (event.target.tagName !== "A") {
          menuItem.classList.toggle("open");
        }
      }
    });
  });

document.addEventListener("DOMContentLoaded", () => {
  // Select all menu items with sub-menus in footer
  const footerMenuItems = document.querySelectorAll(
    "#menu-footer .menu-item-has-children > a"
  );

  footerMenuItems.forEach((menuLink) => {
    menuLink.addEventListener("click", (e) => {
      e.preventDefault(); // Prevent default link behavior

      const parentItem = menuLink.parentElement;
      const subMenu = parentItem.querySelector(".sub-menu");

      // Close other open submenus
      footerMenuItems.forEach((otherLink) => {
        const otherParent = otherLink.parentElement;
        if (otherParent !== parentItem) {
          otherParent.classList.remove("expanded", "open");
        }
      });

      // Toggle the current submenu
      if (subMenu) {
        parentItem.classList.toggle("expanded");
        parentItem.classList.toggle("open");
      }
    });
  });

  // Handle keyboard navigation
  footerMenuItems.forEach((menuLink) => {
    menuLink.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        menuLink.click();
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var header = document.getElementById("main-header");
  var heroSection = document.getElementById("hero-section");
  const onFront =
    document.body.classList.contains("home") ||
    document.body.classList.contains("front-page");

  // Only attach scroll behavior on the front page
  function handleHeaderVisibility() {
    if (!header || !onFront || !heroSection) return;

    const heroHeight = heroSection.offsetHeight;
    const triggerPoint = heroHeight * 0.8;

    if (window.scrollY > triggerPoint) {
      header.classList.remove("lg:hidden");
    } else {
      header.classList.add("lg:hidden");
    }
  }

  if (onFront && header && heroSection) {
    window.addEventListener("scroll", handleHeaderVisibility);
    window.addEventListener("resize", handleHeaderVisibility);
    handleHeaderVisibility();
  } else if (header) {
    // Ensure header is visible immediately on non-front pages
    header.classList.remove("hidden", "lg:hidden");
  }
});

document.addEventListener("DOMContentLoaded", function () {

  // Sélectionner tous les conteneurs de recherche
  const searchContainers = document.querySelectorAll(
    ".search-container, .search-container-frontpage"
  );

  searchContainers.forEach((container, index) => {

    const searchInput = container.querySelector(".search-input");
    const searchToggle = container.querySelector(".search-toggle");
    const closeIcon = container.querySelector(".close-icon");
    let isOpen = false;



    if (!searchInput || !searchToggle || !closeIcon) {
      return;
    }

    // Fonction pour ouvrir la recherche
    function openSearch() {
      isOpen = true;
      searchInput.classList.add("open");
      searchToggle.classList.add("open");
      closeIcon.classList.add("open");
      searchToggle.setAttribute("aria-label", "Fermer la recherche");

      // Focus sur l'input après l'animation
      setTimeout(() => {
        searchInput.focus();
      }, 100);
    }

    // Fonction pour fermer la recherche
    function closeSearch() {
      isOpen = false;
      searchInput.classList.remove("open");
      searchToggle.classList.remove("open");
      closeIcon.classList.remove("open");
      searchToggle.setAttribute("aria-label", "Ouvrir la recherche");
      searchInput.value = ""; // Optionnel: vider le champ
    }

    // Event listener pour le bouton de recherche
    searchToggle.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (!isOpen) {
        openSearch();
      } else {
        closeSearch();
      }
    });

    // Event listener pour le bouton de fermeture
    closeIcon.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeSearch();
    });

    // Fermer avec la touche Escape
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isOpen) {
        closeSearch();
      }
    });

    // Fermer quand on clique à l'extérieur
    document.addEventListener("click", function (e) {
      if (isOpen && !container.contains(e.target)) {
        closeSearch();
      }
    });

    // Empêcher la fermeture quand on clique dans l'input
    searchInput.addEventListener("click", function (e) {
      e.stopPropagation();
    });

    // Support clavier pour le bouton
    searchToggle.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        if (!isOpen) {
          openSearch();
        } else {
          closeSearch();
        }
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
    const track = document.getElementById('realisation-carousel-track');
    const prevBtn = document.querySelector('.realisation-carousel-prev');
    const nextBtn = document.querySelector('.realisation-carousel-next');

    if (!track || !prevBtn || !nextBtn) return;

    const slides = track.querySelectorAll('.carousel-slide');
    const slideCount = slides.length;
    let currentIndex = 0;

    // Swipe variables
    let isDragging = false;
    let startX = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let animationID = 0;

    function updateCarousel(animated = true) {
        const slideWidth = slides[0].getBoundingClientRect().width;
        const translateX = -currentIndex * slideWidth;

        track.style.transition = animated ? 'transform 0.7s ease-out' : 'none';
        track.style.transform = `translateX(${translateX}px)`;

        prevTranslate = translateX;
    }

    function goToNext() {
        currentIndex = (currentIndex + 1) % slideCount;
        updateCarousel();
    }

    function goToPrev() {
        currentIndex = (currentIndex - 1 + slideCount) % slideCount;
        updateCarousel();
    }

    // Touch Events
    function touchStart(event) {
        isDragging = true;
        startX = getPositionX(event);
        animationID = requestAnimationFrame(animation);
        track.style.cursor = 'grabbing';
    }

    function touchMove(event) {
        if (!isDragging) return;

        const currentPosition = getPositionX(event);
        currentTranslate = prevTranslate + currentPosition - startX;
    }

    function touchEnd() {
        isDragging = false;
        cancelAnimationFrame(animationID);
        track.style.cursor = 'grab';

        const movedBy = currentTranslate - prevTranslate;
        const threshold = slides[0].getBoundingClientRect().width * 0.2; // 20% du slide

        // Swipe à gauche (next)
        if (movedBy < -threshold && currentIndex < slideCount - 1) {
            currentIndex += 1;
        }

        // Swipe à droite (prev)
        if (movedBy > threshold && currentIndex > 0) {
            currentIndex -= 1;
        }

        // Loop infini
        if (movedBy < -threshold && currentIndex === slideCount - 1) {
            currentIndex = 0;
        }
        if (movedBy > threshold && currentIndex === 0) {
            currentIndex = slideCount - 1;
        }

        updateCarousel();
    }

    function getPositionX(event) {
        return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    }

    function animation() {
        if (isDragging) {
            track.style.transition = 'none';
            track.style.transform = `translateX(${currentTranslate}px)`;
            requestAnimationFrame(animation);
        }
    }

    // Event Listeners pour les boutons
    nextBtn.addEventListener('click', goToNext);
    prevBtn.addEventListener('click', goToPrev);

    // Event Listeners pour le swipe (Touch)
    track.addEventListener('touchstart', touchStart);
    track.addEventListener('touchmove', touchMove);
    track.addEventListener('touchend', touchEnd);

    // Event Listeners pour le swipe (Mouse - desktop)
    track.addEventListener('mousedown', touchStart);
    track.addEventListener('mousemove', touchMove);
    track.addEventListener('mouseup', touchEnd);
    track.addEventListener('mouseleave', () => {
        if (isDragging) touchEnd();
    });

    // Empêcher le drag d'images
    track.addEventListener('dragstart', (e) => e.preventDefault());

    // Handle resize
    window.addEventListener('resize', () => updateCarousel(false));

    // Initial setup
    track.style.cursor = 'grab';
    updateCarousel(false);
});

(($) => {
  $(document).ready(function () {
    // LIGHTGALLERY - Wrap Gutenberg gallery images in links
    $(".wp-block-gallery.lightgallery").each(function () {
      const $gallery = $(this);

      // Find all images in the gallery
      $gallery.find(".wp-block-image img").each(function () {
        const $img = $(this);
        const $parent = $img.parent();

        // Skip if already wrapped in a link
        if ($parent.is("a")) {
          return;
        }

        // Get full size image URL from srcset or src
        let fullImageUrl = $img.attr("src");
        const srcset = $img.attr("srcset");

        if (srcset) {
          const srcsetArray = srcset.split(",");
          const lastSrcset = srcsetArray[srcsetArray.length - 1].trim();
          fullImageUrl = lastSrcset.split(" ")[0];
        }

        // Get alt text for caption
        const altText = $img.attr("alt") || "";

        // Create wrapper link
        const $link = $("<a>", {
          href: fullImageUrl,
          "data-src": fullImageUrl,
          "data-sub-html": altText ? `<h4>${altText}</h4>` : "",
        });

        // Remove problematic attributes
        $img.removeAttr("width").removeAttr("height").removeAttr("sizes");

        // Force styles with inline CSS (higher specificity than external CSS)
        $img.css({
          "max-width": "365px !important",
          "max-height": "191px !important",
          width: "100%",
          height: "100%",
          "object-fit": "cover",
          "border-radius": "8px",
        });

        // Wrap the image/picture element
        if ($img.parent("picture").length) {
          const $picture = $img.parent("picture");

          // Style the picture element
          $picture.css({
            display: "block",
            "max-width": "365px",
            "max-height": "191px",
            width: "100%",
            height: "100%",
            overflow: "hidden",
            "border-radius": "8px",
          });

          $picture.wrap($link);
        } else {
          $img.wrap($link);
        }
      });

      // Style the figure containers after wrapping
      $gallery.find(".wp-block-image").css({
        "max-width": "365px",
        "max-height": "191px",
        overflow: "hidden",
      });
    });

    // Initialize LightGallery on all galleries
    $(".lightgallery")
      .lightGallery({
        download: false,
        selector: "a",
        counter: true,
        thumbnail: true,
        animateThumb: true,
        showThumbByDefault: false,
      })
      .on("onBeforeSlide.lg", function () {
        $(".lg-backdrop").css("opacity", "0.8");
        $(".lg-sub-html").css("opacity", "0");
      });
  });

  const accordions = $(".wp-block-data-theme-accordion");

  accordions.each(function () {
    const label = $(this).find(".accordion--label");
    const content = $(this).find(".accordion--content");

    label.on("click", function () {
      $(this).toggleClass("active");
      content.slideToggle(300).toggleClass("hidden active");
      $(this).closest(".wp-block-data-theme-accordion").toggleClass("active");
    });
  });

  const glide = new Glide(".glide", {
    type: "carousel",
    perView: 3.02,
    touchAngle: 0,
    breakpoints: {
      1103: {
        touchAngle: 45,
        autoplay: 4000,
        perView: 2.02,
        focusAt: "center",
      },
      506: {
        touchAngle: 45,
        autoplay: 4000,
        perView: 1.03,
        focusAt: "center",
        peek: {
          before: 20,
          after: 20,
        },
      },
    },
  });

  glide.mount();
})(jQuery);
